import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FinancePartnerInfo } from "./financePartnerSlice";


type TinitialState = {
    loading: boolean;
    partners: FinancePartnerInfo[];
    selectedPartners: FinancePartnerInfo[];
    removedPartners: FinancePartnerInfo[];
};
const initialState: TinitialState = {
    partners: [],
    selectedPartners: [],
    removedPartners: [],
    loading: false,
};
const mapPartnerSlice = createSlice({
    name: "mapPartnerSlice",
    initialState: initialState,
    reducers: {
        resetMapPartner: (state, action: PayloadAction<{
            partners: FinancePartnerInfo[],
        }>) => {
            let partners = action.payload.partners.filter((partner) => partner.isMapped);
            return {
                ...initialState,
                selectedPartners: partners,
            };
        },
        setMapPartnersInfo: (state, action: PayloadAction<FinancePartnerInfo[]>) => {
            state.partners = action.payload;
        },
        addPartners: (state, action: PayloadAction<FinancePartnerInfo[]>) => {
            state.selectedPartners = action.payload;
        },
        updateRemovedPartners: (state, action: PayloadAction<FinancePartnerInfo[]>) => {
            state.removedPartners = action.payload;
        },
        removePartner: (state, action: PayloadAction<FinancePartnerInfo>) => {
            let selectedPartner = action.payload;
            if (selectedPartner.id != null && selectedPartner.id > 0) {
                state.removedPartners.push(selectedPartner);
            }
            state.selectedPartners = state.selectedPartners.filter((partner) => partner.finPartnerId != selectedPartner.finPartnerId);
        },
    },
});

export const {
    setMapPartnersInfo,
    resetMapPartner,
    addPartners,
    removePartner,
    updateRemovedPartners,
} = mapPartnerSlice.actions;
export default mapPartnerSlice.reducer;
